import { POSTAL_CODE_BE, COUNTRY_NETHERLANDS } from "../../helpers/consts";

const cssClasses = {
    checkOrderData: 'check-order-data',
    checkOrderDataAdditional: 'check-order-data__additional',
};

export class CheckOrderData {
    constructor(options) {
        this.store = options.store;
        this.state = this.store.getState();
        this.store.subscribe(this.update.bind(this));
        const stateCountryField = this.state.formFields.find(field => field.id === 'companyCountry');
        const stateCountryFieldValue = stateCountryField ? stateCountryField.value : false;
        const productLanguage = this.state.product.language ? this.state.product.language.split('-')[1] : COUNTRY_NETHERLANDS;
        this.country = stateCountryFieldValue || productLanguage;
        this.$el = this.createCheckOrderElement();
        this.update();
        this.store.subscribe(this.update.bind(this));
    }

    createCheckOrderElement() { // eslint-disable-line class-methods-use-this
        const $checkOrderDataElem = document.createElement('div');
        $checkOrderDataElem.classList.add(cssClasses.checkOrderData);

        return $checkOrderDataElem;
    }

    updateOrderData() {
        const fields = this.state.formFields.reduce( (obj, field) => {
            obj[field.id] = field; // eslint-disable-line no-param-reassign
            return obj;
        }, {});

        const checkOrderAddressNlHTML = `
            <dt class='col-sm-12 col-md-4'>${fields.postalCode.label} & huisnummer</dt>
            <dd class='col-sm-12 col-md-8'>${fields.postalCode.value}, ${fields.address.value}</dd>
            <dt class='col-sm-12 col-md-4'>${fields.street.label} & ${fields.city.label} </dt>
            <dd class='col-sm-12 col-md-8'>${fields.street.value}, ${fields.city.value}</dd>
        `;
        const checkOrderAddressBeHTML = `
            <dt class='col-sm-12 col-md-4'>${fields.street.label} & huisnummer</dt>
            <dd class='col-sm-12 col-md-8'>${fields.street.value} ${fields.address.value}</dd>
            <dt class='col-sm-12 col-md-4'>${fields.postalCode.label} & ${fields.city.label} </dt>
            <dd class='col-sm-12 col-md-8'>${fields.postalCode.value} ${fields.city.value}, ${__('Belgium')}</dd>
        `;

        const checkOrderHTML = `
            <h2>${__('Check your data')}</h2>
            <dl class="row">
                <dt class='col-sm-12 col-md-4'>${fields.email.label}</dt>
                <dd class='col-sm-12 col-md-8'>${fields.email.value}</dd>
                <dt class='col-sm-12 col-md-4'>${fields.companyName.label}</dt>
                <dd class='col-sm-12 col-md-8'>${fields.companyName.value}</dd>
                ${ this.country === POSTAL_CODE_BE ? checkOrderAddressBeHTML : checkOrderAddressNlHTML}
            </dl>
            <input id='show-all-data' type='checkbox' class='visually-hidden show-all-data' /><label for='show-all-data' class='label label--show-all-data'>${__('Show all data')}</label>
            <div class='${cssClasses.checkOrderDataAdditional}'>
                <dl class="row">
                    <dt class='col-12 col-md-4'>${fields.firstName.label}</dt>
                    <dd class='col-12 col-md-8'>${fields.firstName.value}</dd>
                    ${fields.insertion.value ? `
                    <dt class='col-12 col-md-4'>${fields.insertion.label}</dt>
                    <dd class='col-12 col-md-8'>${fields.insertion.value}</dd>
                    ` : '' }
                    <dt class='col-12 col-md-4'>${fields.lastName.label}</dt>
                    <dd class='col-12 col-md-8'>${fields.lastName.value}</dd>
                    <dt class='col-12 col-md-4'>${fields.telephone.label}</dt>
                    <dd class='col-12 col-md-8'>${fields.telephone.value}</dd>
                    <dt class='col-12 col-md-4'>${fields.vatNumber.label}</dt>
                    <dd class='col-12 col-md-8'>${fields.vatNumber.value}</dd>
                </dl>
            </div>
        `;

        this.$el.innerHTML = checkOrderHTML;

    }

    update() {
        this.state = this.store.getState();
        this.updateOrderData();
    }

    render() {
        return this.$el;
    }
}

export default CheckOrderData;
